import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url-search-params.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment-timezone';
import { uuid } from 'uuidv4';
import PButton from 'primevue/button';
import PInputNumber from 'primevue/inputnumber';
import PCalendar from 'primevue/calendar';
import PRadioButton from 'primevue/radiobutton';
import PDialog from 'primevue/dialog';
import { ValidationObserver } from 'vee-validate';
import { JwtCredentials } from '@tickethead/sdk';
import TicketPriceListSM from '~/components/Ticket/TicketPriceListSM.vue';
import BChip from '~/components/general/BChip.vue';
import BMobileCart from '~/components/general/BMobileCart.vue';
import DateList from '~/components/Event/DateList.vue';
import IconArrowBack from '~/components/general/icons/IconArrowBack.vue';
import BImageWithBlurredBackground from '~/components/general/BImageWithBlurredBackground.vue';
import TicketPricePreview from '~/components/Ticket/TicketPricePreview.vue';
import TicketPriceList from '~/components/Ticket/TicketPriceList.vue';
import EventInfoPreview from '~/components/Event/EventInfoPreview.vue';
import BAuth from '~/components/general/Auth/BAuth.vue';
import BActionsModal from '~/components/general/BActionsModal.vue';
import { useOrdersStore } from '~/store/orders';
import { useUserStore } from '~/store/user';
import { useAppStore } from '~/store/app';
import TicketFormatSelector from '~/components/Event/TicketFormatSelector.vue';
import { TICKET_FORMATS, EVENT_TYPES, KYC_LEVELS, PAYMENT_TYPES, calculatePriceRange, errorMessage, sortEvents, getTimezoneFromName, sortByDisplayOrder, clone } from '~/utils/utils';
import { applyDiscount } from '~/utils/pricing';
import { isValidHttpUrl } from '~/utils/url';
import { toInitiateCheckoutEvent, toOccurrenceClickEvent } from '~/utils/facebook';
import { toAddToCartEvent, toBeginCheckoutEvent } from '~/utils/gtm';
import { ConditionalTicketValidator } from '~/utils/order/conditionals';
import { isSecondaryMarketUsed } from '~/utils/event/tickets';

/**
 * Companion Options block — the head()/SEO bits, same pattern as
 * `pages/_provider/_id/index.vue`.
 *
 * WHY THIS IS OPTIONS API, NOT `<script setup>`:
 *  - The og:/twitter: meta must server-render. The only reliable SSR path on
 *    `@nuxt/bridge` (`nitro: false`) is Options `head()`, which vue-meta
 *    evaluates at inject time — after `asyncData` has populated the instance.
 *    `useNuxt2Meta` snapshots synchronously inside `setup()` (before `data()`
 *    even runs) and never re-runs on the server, so it renders empty meta
 *    (same failure as `_provider/_id/index.vue`).
 *  - `head()` can only read `this.eventInfo` (the `asyncData` return) plus
 *    things defined in THIS block: Vue 2.7 marks `<script setup>` bindings
 *    `__sfc` and deliberately does not proxy them onto `this`.
 *
 * LIGHTWEIGHT FETCH: `asyncData` does a single `getEvent` (the page was
 * `fetchOnServer: false` pre-migration — SSR did zero API calls — so we keep
 * the added SSR cost to one request). `venue`/`organizer` are NOT fetchable
 * here (`venue` isn't a valid `with` token; the SDK `Event` type has no
 * `organizer` field), so the JSON-LD below server-renders event name / dates /
 * image / offers only, with `location`/`organizer` omitted (the mappers
 * return `undefined` for missing input). The pre-migration page server-
 * rendered NO JSON-LD at all (`fetchOnServer: false` → `jsonld()` returned
 * null on the server), so this is a net gain; it is not the full
 * client-side-reactive JSON-LD the old `jsonld()` mixin produced after the
 * client fetch — that returns in Stage B (below).
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * STAGE B — after the Nuxt 3 flip (Nitro + real useAsyncData / useHead)
 * ─────────────────────────────────────────────────────────────────────────────
 * Delete this whole block and move the head into <script setup>:
 *   const { data: eventInfo } = await useAsyncData('event-info', () =>
 *     query.acc_token
 *       ? sdk.event.getPrivateEvent({ id, access_token: query.acc_token })
 *       : sdk.event.getEvent({ id }));
 *   useHead(() => ({
 *     title: pageTitle.value,
 *     meta: [ ...from eventInfo, unchanged... ],
 *     script: event.value
 *       ? [{ type: 'application/ld+json', innerHTML: JSON.stringify(
 *           mapToEventJsonLd(event.value, route.fullPath,
 *             mapToLocationJsonLd(venue.value),
 *             mapToOrganizerJsonLd(organizer.value))) }]
 *       : []
 *   }));
 * The JSON-LD getter re-runs when the heavy client-fetched refs land, so it is
 * null on the server (client-only fetch) and complete once hydrated —
 * restoring the pre-migration client-side behaviour, minus the stopgaps.
 * Move `pageTitle` / `mainImageUriPreview` / `removeHtmlTags` back to
 * <script setup> too.
 */
import { mapToLocationJsonLd, mapToOrganizerJsonLd, mapToEventJsonLd } from '~/utils/json-ld';
var __default__ = {
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var params, $sdk, query, withQuery, eventInfo, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _ref.params, $sdk = _ref.$sdk, query = _ref.query;
            // Lightweight: one request, just the base event for the meta + a partial
            // JSON-LD. `ticket_config` is the only related data pulled (for the
            // JSON-LD `offers`); everything else the page needs is fetched client-side
            // by the `onMounted` orchestration in <script setup>.
            withQuery = {
              ticket_config: true
            };
            _context.prev = 1;
            $sdk.tenant = params.tenant;
            if (!query.acc_token) {
              _context.next = 3;
              break;
            }
            _context.next = 2;
            return $sdk.event.getPrivateEvent({
              id: params.id,
              access_token: query.acc_token,
              with: withQuery
            });
          case 2:
            eventInfo = _context.sent;
            _context.next = 5;
            break;
          case 3:
            _context.next = 4;
            return $sdk.event.getEvent({
              id: params.id,
              with: withQuery
            });
          case 4:
            eventInfo = _context.sent;
          case 5:
            return _context.abrupt("return", {
              eventInfo: eventInfo
            });
          case 6:
            _context.prev = 6;
            _t = _context["catch"](1);
            console.log(_t);
            return _context.abrupt("return", {
              eventInfo: {}
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    }))();
  },
  computed: {
    pageTitle: function pageTitle() {
      var _this$eventInfo;
      if ((_this$eventInfo = this.eventInfo) !== null && _this$eventInfo !== void 0 && _this$eventInfo.name) {
        return "".concat(this.eventInfo.name, " | ").concat(this.$t('page.title'));
      }
      return this.$t('page.title');
    },
    mainImageUriPreview: function mainImageUriPreview() {
      var _this$eventInfo2, _this$eventInfo2$main;
      return ((_this$eventInfo2 = this.eventInfo) === null || _this$eventInfo2 === void 0 ? void 0 : (_this$eventInfo2$main = _this$eventInfo2.mainImageUri) === null || _this$eventInfo2$main === void 0 ? void 0 : _this$eventInfo2$main.replace('16x9', '4x3')) ||
      // eslint-disable-next-line no-undef
      require('assets/img/event_placeholder.webp').replace('16x9', '4x3');
    }
  },
  methods: {
    removeHtmlTags: function removeHtmlTags(description) {
      if (!description) {
        return;
      }
      var tagsToRemove = /<\/?(h1|h2|h3|br|hr|blockquote|s|u|i|b|code|ol|ul)[^>]*>/gi;
      return description.replace(/<p>/gi, '').replace(/<\/p>/gi, '\n').replace(tagsToRemove, '');
    }
  },
  head: function head() {
    var _info$venue, _info$occurrence, _info$occurrence$, _this$eventInfo3, _this$eventInfo4, _this$eventInfo5;
    var info = this.eventInfo;
    var script = info && info.mainImageUri ? [{
      hid: 'jsonld',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(mapToEventJsonLd(info, this.$route.fullPath, mapToLocationJsonLd((_info$venue = info.venue) !== null && _info$venue !== void 0 ? _info$venue : (_info$occurrence = info.occurrence) === null || _info$occurrence === void 0 ? void 0 : (_info$occurrence$ = _info$occurrence[0]) === null || _info$occurrence$ === void 0 ? void 0 : _info$occurrence$.venue), mapToOrganizerJsonLd(info.organizer)))
    }] : [];
    return {
      title: this.pageTitle,
      script: script,
      meta: [{
        hid: 'og:title',
        property: 'og:title',
        content: this.eventInfo.name
      }, {
        hid: 'og:site_name',
        property: 'og:site_name',
        content: this.pageTitle
      }, {
        hid: 'og:image',
        property: 'og:image',
        content: this.mainImageUriPreview
      }, {
        hid: 'og:image:url',
        property: 'og:image:url',
        content: this.mainImageUriPreview
      }, {
        hid: 'og:image:type',
        property: 'og:image:type',
        content: 'image/webp'
      }, {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.mainImageUriPreview
      }, {
        hid: 'og:description',
        property: 'og:description',
        content: this.removeHtmlTags((_this$eventInfo3 = this.eventInfo) === null || _this$eventInfo3 === void 0 ? void 0 : _this$eventInfo3.description)
      }, {
        hid: 'twitter:card',
        property: 'twitter:card',
        content: 'summary'
      }, {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: (_this$eventInfo4 = this.eventInfo) === null || _this$eventInfo4 === void 0 ? void 0 : _this$eventInfo4.name
      }, {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: (_this$eventInfo5 = this.eventInfo) === null || _this$eventInfo5 === void 0 ? void 0 : _this$eventInfo5.description
      }, {
        hid: 'twitter:image',
        property: 'twitter:image',
        content: this.mainImageUriPreview
      }]
    };
  }
};
const __nuxt_page_meta = {
  layout: 'default_v2'
}
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  ...__nuxt_page_meta,__name: 'index',
  setup: function setup(__props) {
    var SelectSeatsModes = {
      BestAvailable: 0,
      ManuallyChosen: 1
    };
    ;

    // Captured once during setup — `getCurrentInstance()` returns null when called
    // later from a computed getter. Used only to read `eventInfo` (asyncData data,
    // which lives on the instance, not as a <script setup> binding).
    var instance = getCurrentInstance();
    var route = useRoute();
    var router = useRouter();
    var localePath = useLocalePath();
    var appStore = useAppStore();
    var userStore = useUserStore();
    var ordersStore = useOrdersStore();
    var sdk = useSdk();
    var services = useServices();
    var notifier = useNotifier();
    var auth = useAuth();
    var whitelabel = useWhitelabel();
    var runtimeConfig = useRuntimeConfig();
    var nuxtApp = useNuxtApp();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useBreakpoint = useBreakpoint(),
      xsOnly = _useBreakpoint.xsOnly,
      mdAndDown = _useBreakpoint.mdAndDown;
    var _useGtm = useGtm(),
      setupGtm = _useGtm.setupGtm,
      gtmPush = _useGtm.gtmPush;
    var _useMetaPixel = useMetaPixel(),
      setupMetaPixel = _useMetaPixel.setupMetaPixel,
      disableMetaPixel = _useMetaPixel.disableMetaPixel,
      trackMetaEvent = _useMetaPixel.trackMetaEvent;
    var featureFlags = useFeatureFlags();
    var bus = useNuxtEventBus();

    // --- constants -------------------------------------------------------------
    var eventTypes = EVENT_TYPES;
    var tabName = {
      Tickets: 0,
      EventInfo: 1,
      Secondary: 2
    };
    var formats = TICKET_FORMATS;
    var minDonationAmount = 2; // min payment amount
    var maxDonationAmount = 100000;
    var defaultPaymentProvider = 'global-payments';
    var radioButtonOptions = [{
      label: t('buyTickets.seatsOptions.manuallyChosen'),
      value: SelectSeatsModes.ManuallyChosen,
      group: 'selectSeatsMode',
      message: t('buyTickets.seatsOptions.manuallyChosen.info')
    }, {
      label: t('buyTickets.seatsOptions.bestAvailable'),
      value: SelectSeatsModes.BestAvailable,
      group: 'selectSeatsMode',
      message: t('buyTickets.seatsOptions.bestAvailable.info')
    }];
    var tenant = route.params.tenant;
    var eventId = route.params.id;

    // --- non-reactive locals -------------------------------------------------
    var validator = new ConditionalTicketValidator();
    var seatingChart = null;
    var workspaceKey = '';
    var ignoreNextDeselection = false;

    // --- template refs ------------------------------------------------------
    var observer = ref();
    // Replaces <v-window>: which step is showing + the slide direction.
    var stepReverse = ref(false);
    // Replaces the <v-img> #placeholder spinner in the sector-map dialog.
    var sectorMapLoaded = ref(false);

    // --- reactive state ---------------------------------------------------
    var donationDialog = ref(false);
    var donationTicket = ref(null);
    var donationAmount = ref(null);
    var mobileCartVisible = ref(false);
    var currentTab = ref(0);
    var loading = ref(true);
    var event = ref(null);
    var originalEventData = ref(null);
    var discountCode = ref('');
    var offers = ref(null);
    var showSeatsOverlay = ref(false);
    var seatsioEventId = ref(null);
    var eventLoaded = ref(false);
    var stepTickets = ref(null);
    var organizer = ref(null);
    var tickets = ref([]);
    var selectedTickets = ref([]);
    var selectedTicketsSM = ref([]);
    var ticketsSM = ref([]);
    var errorDialog = ref(false);
    var dialog = ref(false);
    var qrcodeImage = ref('');
    var format = ref(null);
    var selectedTimeslot = ref(null);
    var selectedOccurrence = ref(null);
    var selectedDateRange = ref(null);
    var imageScale = ref(100);
    var hideBottomText = ref(false);
    var sectorMap = ref(false);
    var datePickerClicks = ref(0);
    var preparedSectors = ref([]);
    var config = reactive({
      eventDescription: true,
      startDate: null,
      eventFoundByDate: false,
      showHeader: true
    });
    var openCart = ref(false);
    var openSecondaryCart = ref(false);
    var ownedTickets = ref([]);
    var seatSelectionValid = ref(false);
    var orderExists = ref(false);
    var discountCodeValue = ref(null);
    var prefillTicketConfigId = ref(null);
    var showPrimaryCartForSeatedEvents = ref(false);
    var showSecondaryCartForSeatedEvents = ref(false);
    var accessCode = ref(null);
    var selectSeatsMode = ref(SelectSeatsModes.ManuallyChosen);

    // --- store getters (mapGetters) ------------------------------------------
    var getReducedOrder = computed(function () {
      return ordersStore.getReducedOrder;
    });
    var getLoading = computed(function () {
      return appStore.getLoading;
    });
    var getAuthDialog = computed(function () {
      return appStore.getAuthDialog;
    });
    var isOnSiteSeller = computed(function () {
      return userStore.canManuallyConfirmOrder;
    });

    // --- computed --------------------------------------------------------
    var showPrimaryCart = computed(function () {
      if (isSeatedEvent.value && !showPrimaryCartForSeatedEvents.value) {
        return false;
      }
      return true;
    });
    var showSecondaryCart = computed(function () {
      if (isSeatedEvent.value && !showSecondaryCartForSeatedEvents.value || !isSeatedEvent.value) {
        return false;
      }
      return true;
    });
    // mainImageUriPreview / pageTitle / removeHtmlTags moved to the companion
    // <script> block (they serve head() and only need `eventInfo`).
    var mainImageUri = computed(function () {
      var _instance$proxy, _instance$proxy$event;
      return (instance === null || instance === void 0 ? void 0 : (_instance$proxy = instance.proxy) === null || _instance$proxy === void 0 ? void 0 : (_instance$proxy$event = _instance$proxy.eventInfo) === null || _instance$proxy$event === void 0 ? void 0 : _instance$proxy$event.mainImageUri) || require('assets/img/event_placeholder.webp');
    });
    var showSecondaryMarket = computed(
    // The SM tab is shown if the feature flag is active and a ticket config uses it
    function () {
      return featureFlags.showSecondary && isSecondaryMarketUsed(event.value);
    });
    var tabs = computed(function () {
      var displayedTabs = [{
        label: t('main.tabs.tickets'),
        name: 'tickets'
      }, {
        label: t('main.tabs.eventInfo'),
        name: 'name'
      }];
      if (showSecondaryMarket.value && !event.value.chartKey) {
        displayedTabs.push({
          label: t('main.secondaryMarket'),
          name: 'secondary'
        });
      }
      return displayedTabs;
    });
    var total = computed(function () {
      var _currency$value;
      var isCrypto = whitelabel.supportedCryptoCurrencies.includes((_currency$value = currency.value) === null || _currency$value === void 0 ? void 0 : _currency$value.toUpperCase());
      var sum = selectedTickets.value.reduce(function (acc, ticket) {
        if (ticket.donationAmount) {
          return acc + parseFloat(ticket.donationAmount);
        }
        return acc + parseFloat(ticket.finalPrice);
      }, 0);
      return sum.toFixed(isCrypto ? 8 : 2);
    });
    var numberOfTickets = computed(function () {
      return selectedTickets.value.length;
    });
    var currency = computed(function () {
      var _event$value, _event$value$ticketCo;
      if (((_event$value = event.value) === null || _event$value === void 0 ? void 0 : (_event$value$ticketCo = _event$value.ticketConfig) === null || _event$value$ticketCo === void 0 ? void 0 : _event$value$ticketCo.length) !== 0) {
        var _event$value2, _event$value2$ticketC, _offers$value, _offers$value$;
        return currentTab.value === tabName.Tickets ? (_event$value2 = event.value) === null || _event$value2 === void 0 ? void 0 : (_event$value2$ticketC = _event$value2.ticketConfig) === null || _event$value2$ticketC === void 0 ? void 0 : _event$value2$ticketC[0].currency : (_offers$value = offers.value) === null || _offers$value === void 0 ? void 0 : (_offers$value$ = _offers$value[0]) === null || _offers$value$ === void 0 ? void 0 : _offers$value$.currency;
      }
      return '';
    });
    var isRecurring = computed(function () {
      return event.value.type === eventTypes.RECURRING;
    });
    var cartDisabled = computed(function () {
      var _event$value3;
      return moment((_event$value3 = event.value) === null || _event$value3 === void 0 ? void 0 : _event$value3.endAt).isBefore(moment());
    });
    var subcategory = computed(function () {
      var _event$value4, _event$value4$subcate;
      return (_event$value4 = event.value) === null || _event$value4 === void 0 ? void 0 : (_event$value4$subcate = _event$value4.subcategory) === null || _event$value4$subcate === void 0 ? void 0 : _event$value4$subcate.name;
    });
    var hasSectors = computed(function () {
      var _event$value5, _event$value5$sector;
      if (isRecurring.value) {
        var _selectedOccurrence$v, _selectedOccurrence$v2;
        return ((_selectedOccurrence$v = selectedOccurrence.value) === null || _selectedOccurrence$v === void 0 ? void 0 : (_selectedOccurrence$v2 = _selectedOccurrence$v.sector) === null || _selectedOccurrence$v2 === void 0 ? void 0 : _selectedOccurrence$v2.length) > 0;
      }
      return ((_event$value5 = event.value) === null || _event$value5 === void 0 ? void 0 : (_event$value5$sector = _event$value5.sector) === null || _event$value5$sector === void 0 ? void 0 : _event$value5$sector.length) > 0;
    });
    var hasTimeslots = computed(function () {
      var _event$value6, _event$value6$timeslo;
      return ((_event$value6 = event.value) === null || _event$value6 === void 0 ? void 0 : (_event$value6$timeslo = _event$value6.timeslot) === null || _event$value6$timeslo === void 0 ? void 0 : _event$value6$timeslo.length) > 0;
    });
    var hasConditionalTickets = computed(function () {
      var _selectedOccurrence$v3, _event$value7;
      var ticketConfigs = isRecurring.value ? (_selectedOccurrence$v3 = selectedOccurrence.value) === null || _selectedOccurrence$v3 === void 0 ? void 0 : _selectedOccurrence$v3.ticketConfig : (_event$value7 = event.value) === null || _event$value7 === void 0 ? void 0 : _event$value7.ticketConfig;
      return (ticketConfigs === null || ticketConfigs === void 0 ? void 0 : ticketConfigs.length) && ticketConfigs.some(function (tc) {
        return configIsConditional(tc);
      });
    });
    var priceListKey = computed(function () {
      if (hasSectors.value) {
        var _event$value$selected;
        return (_event$value$selected = event.value.selectedSector) === null || _event$value$selected === void 0 ? void 0 : _event$value$selected.id;
      }
      if (hasTimeslots.value) {
        var _selectedTimeslot$val;
        return (_selectedTimeslot$val = selectedTimeslot.value) === null || _selectedTimeslot$val === void 0 ? void 0 : _selectedTimeslot$val.id;
      }
      return null;
    });
    var showDateTimePicker = computed(function () {
      var _event$value8, _event$value9, _event$value9$timeslo;
      return ((_event$value8 = event.value) === null || _event$value8 === void 0 ? void 0 : _event$value8.type) === eventTypes.RECURRING || ((_event$value9 = event.value) === null || _event$value9 === void 0 ? void 0 : (_event$value9$timeslo = _event$value9.timeslot) === null || _event$value9$timeslo === void 0 ? void 0 : _event$value9$timeslo.length) > 0;
    });
    // Replaces <v-window-item v-if="showDateTimePicker"> at index 0: true while the
    // date/timeslot picker is showing, false on the ticket-selection step. When
    // there is no date picker, `stepTickets` stays null and this is always false
    // (matches Vuetify rendering the lone window item).
    var datePickerStep = computed(function () {
      return showDateTimePicker.value && (stepTickets.value === null || stepTickets.value < 1);
    });
    var isMobile = xsOnly;
    var isSmallDevice = mdAndDown;
    var venue = computed(function () {
      var _event$value0;
      if (event.value.type === EVENT_TYPES.RECURRING) {
        var _selectedOccurrence$v4;
        return (_selectedOccurrence$v4 = selectedOccurrence.value) === null || _selectedOccurrence$v4 === void 0 ? void 0 : _selectedOccurrence$v4.venue;
      }
      return (_event$value0 = event.value) === null || _event$value0 === void 0 ? void 0 : _event$value0.venue;
    });
    var filteredDates = computed(function () {
      var _selectedDateRange$va, _event$value10;
      if (datePickerClicks.value > 1 && ((_selectedDateRange$va = selectedDateRange.value) === null || _selectedDateRange$va === void 0 ? void 0 : _selectedDateRange$va.length) > 0) {
        var _event$value1, _event$value1$occurre;
        return (_event$value1 = event.value) === null || _event$value1 === void 0 ? void 0 : (_event$value1$occurre = _event$value1.occurrence) === null || _event$value1$occurre === void 0 ? void 0 : _event$value1$occurre.filter(function (date) {
          return moment(date.startAt).isBetween(moment(selectedDateRange.value[0]), moment(selectedDateRange.value[1]), 'day', '[]');
        });
      }
      return (_event$value10 = event.value) === null || _event$value10 === void 0 ? void 0 : _event$value10.occurrence;
    });
    var hasFilteredEvents = computed(function () {
      return config.eventFoundByDate;
    });
    var showEvent = computed(function () {
      return event.value && !config.startDate || config.startDate && hasFilteredEvents.value;
    });
    var selectionValid = computed(function () {
      if (isSeatedEvent.value && selectSeatsMode.value === SelectSeatsModes.ManuallyChosen) {
        return seatSelectionValid.value;
      }
      return true;
    });
    var isSeatedEvent = computed(function () {
      if (isRecurring.value) {
        var _selectedOccurrence$v5;
        return (_selectedOccurrence$v5 = selectedOccurrence.value) === null || _selectedOccurrence$v5 === void 0 ? void 0 : _selectedOccurrence$v5.chartKey;
      }
      return event.value.chartKey;
    });
    var eventHasPassed = computed(function () {
      return moment(event.value.endAt).isBefore(moment());
    });
    var eventInPresale = computed(function () {
      if (selectedOccurrence.value) {
        return selectedOccurrence.value.presaleEndAt && moment(selectedOccurrence.value.presaleEndAt).isAfter(moment());
      }
      return event.value.presaleEndAt && moment(event.value.presaleEndAt).isAfter(moment());
    });
    var showSeatmap = computed(function () {
      return selectSeatsMode.value === SelectSeatsModes.ManuallyChosen;
    });
    var isGlobalPayments = computed(function () {
      return defaultPaymentProvider === 'global-payments';
    });
    var onSiteSaleOnlyEvent = computed(function () {
      if (isRecurring.value) {
        return event.value.occurrence.every(function (occurrence) {
          return occurrence.ticketConfig.length === 0 || !occurrence.ticketConfig.some(function (ticketConfig) {
            return ticketConfig.onSiteSale === false;
          });
        });
      }
      return event.value.ticketConfig.length === 0 || !event.value.ticketConfig.some(function (ticketConfig) {
        return ticketConfig.onSiteSale === false;
      });
    });

    // computed-returning-a-function → plain function (playbook)
    function conditionalTicketingSatisfied(ticketConfig) {
      if (!configIsConditional(ticketConfig)) {
        return true;
      }
      return validator.canAddTicket(ticketConfig, ownedTickets.value, selectedTickets.value);
    }

    // --- watch --------------------------------------------------------
    watch(getAuthDialog, function (newValue) {
      if (newValue && selectedTickets.value.length > 0) {
        openCart.value = true;
      }
    });
    watch(format, function (newValue) {
      appStore.setEnableGuestLogin(newValue === 'PDF');
    });
    watch(selectedDateRange, function () {
      datePickerClicks.value++;
    });
    watch(hideBottomText, function (newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        imageScale.value = 100;
      }
    });
    watch(function () {
      var _organizer$value;
      return (_organizer$value = organizer.value) === null || _organizer$value === void 0 ? void 0 : _organizer$value.workspaceKey;
    }, function (newValue, oldValue) {
      if (newValue !== oldValue && isSeatedEvent.value) {
        nextTick(function () {
          fetchSeats();
        });
      } else {
        eventLoaded.value = true;
      }
    });
    // These arrays are mutated in place (push/splice), so watch the length —
    // `watch(ref, cb)` alone only fires on `.value` reassignment, unlike the
    // Options-API watcher this replaced, which fired on mutation too.
    watch(function () {
      return selectedTickets.value.length;
    }, function (len) {
      openCart.value = len > 0;
      showPrimaryCartForSeatedEvents.value = len > 0;
    });
    watch(function () {
      return selectedTicketsSM.value.length;
    }, function (len) {
      if (len > 0) {
        openSecondaryCart.value = true;
      } else {
        openSecondaryCart.value = false;
        showSecondaryCartForSeatedEvents.value = false;
      }
    });
    watch(function () {
      return config.startDate;
    }, function (newValue) {
      if (newValue) {
        var _event$value11, _event$value11$occurr;
        var foundOccurrence = (_event$value11 = event.value) === null || _event$value11 === void 0 ? void 0 : (_event$value11$occurr = _event$value11.occurrence) === null || _event$value11$occurr === void 0 ? void 0 : _event$value11$occurr.find(function (occurrence) {
          return moment(occurrence.startAt).isSame(moment(newValue), 'day');
        });
        if (foundOccurrence) {
          selectOccurrence({
            occurrence: foundOccurrence
          });
          config.eventFoundByDate = true;
        } else {
          config.eventFoundByDate = false;
        }
      }
    });
    watch(selectSeatsMode, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        clearTicketPreview(false);
        if (newValue === SelectSeatsModes.ManuallyChosen) {
          renderSeatingChart();
        }
      }
    });

    // --- lifecycle --------------------------------------------------------
    bus.$on('onLogin', onLogin);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var urlParams, description, header, startDate, discountCodeParam, ticketConfigId, _organizer$value2, _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            urlParams = new URLSearchParams(window.location.search);
            description = urlParams.get('description');
            header = urlParams.get('header');
            startDate = urlParams.get('start_date');
            discountCodeParam = urlParams.get('discountCode');
            ticketConfigId = urlParams.get('ticketConfigId');
            if (description === 'false') {
              config.eventDescription = false;
            }
            if (header === 'false') {
              config.showHeader = false;
            }
            if (startDate) {
              config.startDate = startDate;
            }
            if (discountCodeParam) {
              discountCodeValue.value = discountCodeParam;
            }
            if (ticketConfigId) {
              prefillTicketConfigId.value = ticketConfigId;
            }

            // Was the Options `fetch()` hook (`fetchOnServer: false` → client-only).
            _context2.prev = 1;
            appStore.setLoading(true);
            _context2.next = 2;
            return getEvent();
          case 2:
            redirectIfNeeded(event.value);
            _context2.next = 3;
            return getVenue();
          case 3:
            if (!showSecondaryMarket.value) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return getSecondaryTickets();
          case 4:
            _context2.next = 5;
            return getOrganizer();
          case 5:
            bus.$emit('organizerFetched', organizer.value);
            // The tenant needs to be set or fetchOwnedTickets will fail on the TH env
            sdk.tenant = tenant;
            if (!auth.loggedIn) {
              _context2.next = 6;
              break;
            }
            _context2.next = 6;
            return fetchOwnedTickets();
          case 6:
            setupMetaPixel(organizer.value);
            setupGtm((_organizer$value2 = organizer.value) === null || _organizer$value2 === void 0 ? void 0 : _organizer$value2.gtmId);
            handleOccurrenceLink();
            if (prefillTicketConfigId.value) {
              handleTicketConfigPrefill();
            }
            _context2.next = 8;
            break;
          case 7:
            _context2.prev = 7;
            _t2 = _context2["catch"](1);
            notifier.showMessage({
              content: errorMessage(_t2, t('errors.fetchEvent')),
              type: 'error'
            });
          case 8:
            _context2.prev = 8;
            appStore.setLoading(false);
            return _context2.finish(8);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 7, 8, 9]]);
    })));
    onBeforeUnmount(function () {
      var _seatingChart;
      bus.$off('onLogin');
      disableMetaPixel(organizer.value);
      if ((_seatingChart = seatingChart) !== null && _seatingChart !== void 0 && _seatingChart.iframe) {
        seatingChart.destroy();
      }
    });

    // --- methods --------------------------------------------------------
    function handleTicketConfigPrefill() {
      var foundTicketConfig = event.value.ticketConfig.find(function (tc) {
        return tc.id === parseInt(prefillTicketConfigId.value);
      });
      var preparedTicket = {
        ticket: foundTicketConfig,
        discount: foundTicketConfig.discount
      };
      addTicket(preparedTicket);
    }
    function handleOccurrenceLink() {
      var urlParams = new URLSearchParams(window.location.search);
      var occurrenceId = parseInt(urlParams.get('occurrence_id'));
      if (occurrenceId) {
        var foundOccurrence = event.value.occurrence.find(function (occurrence) {
          return occurrence.id === occurrenceId;
        });
        if (foundOccurrence) {
          selectOccurrence({
            occurrence: foundOccurrence
          });
        }
      }
    }
    // NOTE: id property of the returned object is id of the ticket config
    // id of the ticket itself is preserved in the ticketId property
    function adjustOrderTicketForCart(ticket) {
      var _ticket$timeslot, _ticket$timeslot2, _ticket$timeslot3, _ticket$timeslot4;
      return _objectSpread(_objectSpread({}, ticket), {}, {
        discount: ticket.ticketDiscount[0],
        kycLevelId: ticket.ticketConfig.kycLevelId,
        id: ticket.ticketConfig.id,
        name: ticket.ticketConfig.name,
        pricingType: ticket.ticketConfig.pricingType,
        timeslotId: (_ticket$timeslot = ticket.timeslot) === null || _ticket$timeslot === void 0 ? void 0 : _ticket$timeslot.id,
        timeslotName: (_ticket$timeslot2 = ticket.timeslot) === null || _ticket$timeslot2 === void 0 ? void 0 : _ticket$timeslot2.name,
        timeslotStartAt: (_ticket$timeslot3 = ticket.timeslot) === null || _ticket$timeslot3 === void 0 ? void 0 : _ticket$timeslot3.startAt,
        timeslotEndAt: (_ticket$timeslot4 = ticket.timeslot) === null || _ticket$timeslot4 === void 0 ? void 0 : _ticket$timeslot4.endAt,
        ticketId: ticket.id,
        donationAmount: isDonation(ticket.ticketConfig.pricingType) ? ticket.grossPrice : null
      });
    }
    function populateCart(eventType) {
      if (eventType === eventTypes.SINGLE) {
        var reducedOrder = getReducedOrder.value(eventId);
        if (reducedOrder && reducedOrder.market === 'primary') {
          var ticketsHaveSeats = reducedOrder.tickets.some(function (t) {
            var _t$seat;
            return t.seatId || ((_t$seat = t.seat) === null || _t$seat === void 0 ? void 0 : _t$seat.id);
          });
          if (ticketsHaveSeats) {
            // If there are tickets in the cart with seats, we clear the cart to
            // prevent tickets being added twice (they're re-added by addSeat).
            selectedTickets.value.splice(0, selectedTickets.value.length);
          } else {
            selectedTickets.value = reducedOrder.tickets.map(function (ticket) {
              return adjustOrderTicketForCart(ticket);
            });
          }
          orderExists.value = true;
        }
      }
    }
    function adjustRecurringEventDates(evt) {
      sortEvents(evt.occurrence);
      var numberOfOccurrences = evt.occurrence.length;
      if (numberOfOccurrences > 0) {
        evt.startAt = evt.occurrence[0].startAt;
        evt.endAt = evt.occurrence[numberOfOccurrences - 1].endAt;
      }
    }
    function assignVenuesToOccurrences(_x) {
      return _assignVenuesToOccurrences.apply(this, arguments);
    }
    function _assignVenuesToOccurrences() {
      _assignVenuesToOccurrences = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(occurrences) {
        var venueIds, venues, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              venueIds = _toConsumableArray(new Set(occurrences.map(function (occurrence) {
                return occurrence.venueId;
              })));
              _context3.next = 1;
              return sdk.venue.getVenues({
                ids: venueIds
              });
            case 1:
              venues = _context3.sent;
              return _context3.abrupt("return", occurrences.map(function (occurrence) {
                var v = venues.find(function (vn) {
                  return Number(vn.id) === Number(occurrence.venueId);
                });
                occurrence.venue = v;
                return occurrence;
              }));
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t3, t('errors.fetchVenue')),
                type: 'error'
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return _assignVenuesToOccurrences.apply(this, arguments);
    }
    function configIsConditional(cfg) {
      var _cfg$dependsOn;
      return (cfg === null || cfg === void 0 ? void 0 : (_cfg$dependsOn = cfg.dependsOn) === null || _cfg$dependsOn === void 0 ? void 0 : _cfg$dependsOn.length) > 0;
    }
    function conditionalConfigText(cfg) {
      var _cfg$dependsOn2;
      return cfg === null || cfg === void 0 ? void 0 : (_cfg$dependsOn2 = cfg.dependsOn) === null || _cfg$dependsOn2 === void 0 ? void 0 : _cfg$dependsOn2.map(function (tc) {
        return tc === null || tc === void 0 ? void 0 : tc.name;
      }).join(', ');
    }
    function isDonation(type) {
      return type === PAYMENT_TYPES.DONATION;
    }
    function showDonationDialog(donationDialogShown) {
      var _donationTicket$value;
      donationDialog.value = donationDialogShown;
      var seat = (_donationTicket$value = donationTicket.value) === null || _donationTicket$value === void 0 ? void 0 : _donationTicket$value.seat;
      if (seat && !donationDialogShown && !donationAmount.value) {
        seat.deselect(seat.selectedTicketType);
      }
      if (donationDialog.value) {
        document.documentElement.style.overflow = 'hidden';
        document.body.scroll = 'no';
      } else {
        document.documentElement.style.overflow = 'scroll';
        document.body.scroll = 'yes';
      }
    }
    function openMobileCart() {
      mobileCartVisible.value = true;
      document.documentElement.style.overflow = 'hidden';
      document.body.scroll = 'no';
    }
    function closeMobileCart() {
      mobileCartVisible.value = false;
      document.documentElement.style.overflow = 'scroll';
      document.body.scroll = 'yes';
    }
    function clearMobileCart() {
      clearTicketPreview();
      closeMobileCart();
    }
    function removeFromMobileCart(_x2) {
      return _removeFromMobileCart.apply(this, arguments);
    }
    function _removeFromMobileCart() {
      _removeFromMobileCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref3) {
        var ticket, index;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              ticket = _ref3.ticket, index = _ref3.index;
              _context4.next = 1;
              return removeTicketPreview({
                ticket: ticket,
                index: index
              });
            case 1:
              if (selectedTickets.value.length === 0) {
                closeMobileCart();
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _removeFromMobileCart.apply(this, arguments);
    }
    function submitOrder(discount, access) {
      showDialog(discount, access);
      closeMobileCart();
    }
    function closeAuthDialog() {
      appStore.setAuthDialog(false);
      appStore.setEnableGuestLogin(false);
      document.body.style = '';
    }
    function openLogin() {
      appStore.setAuthDialog(true);
      openCart.value = false;
      document.body.style = 'height: 100vh; overflow-y: hidden';
    }
    function onLogin() {
      return _onLogin.apply(this, arguments);
    }
    function _onLogin() {
      _onLogin = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              appStore.setLoading(true);
              // Also needed when login was triggered from the ticket list, format still null
              _context5.next = 1;
              return fetchOwnedTickets();
            case 1:
              if (!format.value) {
                _context5.next = 3;
                break;
              }
              if (!(selectedTickets.value.length !== 0)) {
                _context5.next = 2;
                break;
              }
              _context5.next = 2;
              return createOrder();
            case 2:
              if (!(selectedTicketsSM.value.length !== 0)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 3;
              return createSMOrder();
            case 3:
              appStore.setLoading(false);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _onLogin.apply(this, arguments);
    }
    function preparedTicketConfigs() {
      if (hasSectors.value) {
        var _event$value12, _event$value12$select;
        return (_event$value12 = event.value) === null || _event$value12 === void 0 ? void 0 : (_event$value12$select = _event$value12.selectedSector) === null || _event$value12$select === void 0 ? void 0 : _event$value12$select.ticketConfig.map(function (tc) {
          return _objectSpread({}, event.value.ticketConfig.find(function (etc) {
            return etc.id === tc.id;
          }));
        }).filter(function (tc) {
          return tc.visible;
        });
      }
      return event.value.ticketConfig;
    }
    function findDiscount(discountId) {
      var _event$value$ticketDi;
      return (_event$value$ticketDi = event.value.ticketDiscount) === null || _event$value$ticketDi === void 0 ? void 0 : _event$value$ticketDi.find(function (td) {
        return td.id === discountId;
      });
    }
    function findPreparedTicketConfig(ticketConfigId) {
      return event.value.ticketConfig.find(function (tc) {
        return tc.id === ticketConfigId;
      });
    }
    function findOriginalTicketConfig(ticketConfigId) {
      return originalEventData.value.ticketConfig.find(function (tc) {
        return tc.id === ticketConfigId;
      });
    }
    function findTicketConfig(ticketConfigId, occurrenceId) {
      var _findPreparedTicketCo;
      if (occurrenceId) {
        var occurrence = event.value.occurrence.find(function (o) {
          return o.id === occurrenceId;
        });
        return occurrence.ticketConfig.find(function (tc) {
          return tc.id === ticketConfigId;
        });
      }
      return (_findPreparedTicketCo = findPreparedTicketConfig(ticketConfigId)) !== null && _findPreparedTicketCo !== void 0 ? _findPreparedTicketCo : findOriginalTicketConfig(ticketConfigId);
    }
    function selectSector(sector) {
      if (isRecurring.value) {
        event.value.selectedSector = selectedOccurrence.value.sector.find(function (s) {
          return sector.includes(s.id);
        });
      } else {
        event.value.selectedSector = event.value.sector.find(function (s) {
          return sector.includes(s.id);
        });
      }
    }
    function goBackToOccurrences() {
      if (selectedOccurrence.value.chartKey) {
        showSeatsOverlay.value = false;
        seatingChart.destroy();
      }
      selectedOccurrence.value = null;
      selectedTimeslot.value = null;
      event.value.selectedSector = null;
      stepReverse.value = true;
      stepTickets.value--;
    }
    function openWarningDialog(tab) {
      switch (tab) {
        case 'tickets':
          errorDialog.value = selectedTicketsSM.value.length !== 0;
          break;
        case 'secondary':
          errorDialog.value = selectedTickets.value.length !== 0;
          break;
      }
    }
    function goToPreviousTab() {
      currentTab.value = currentTab.value === tabName.Tickets ? tabName.Secondary : tabName.Tickets;
      errorDialog.value = false;
    }
    function clearCartAndCloseDialog(tab) {
      errorDialog.value = false;
      if (tab === tabName.Secondary) {
        ticketsSM.value = ticketsSM.value.concat(selectedTicketsSM.value);
        while (selectedTicketsSM.value.length > 0) {
          selectedTicketsSM.value.pop();
        }
      } else {
        clearTicketPreview();
      }
    }
    function showSectorMap() {
      sectorMapLoaded.value = false;
      sectorMap.value = true;
    }
    function isFormatSupported(fmt) {
      var _event$value13, _event$value13$ticket;
      return (_event$value13 = event.value) === null || _event$value13 === void 0 ? void 0 : (_event$value13$ticket = _event$value13.ticketFormat) === null || _event$value13$ticket === void 0 ? void 0 : _event$value13$ticket.some(function (tf) {
        return tf.name.toLowerCase() === fmt;
      });
    }
    function setTicketFormat(fmt) {
      switch (fmt) {
        case TICKET_FORMATS.SECURE:
          if (!event.value.ticketFormat.find(function (tf) {
            return tf.name === 'secure';
          })) {
            return;
          }
          break;
        case TICKET_FORMATS.PDF:
        case TICKET_FORMATS.PKPASS:
          if (!event.value.ticketFormat.find(function (tf) {
            return tf.name === 'pdf';
          }) && !event.value.ticketFormat.find(function (tf) {
            return tf.name === 'pkpass';
          })) {
            return;
          }
          break;
      }
      format.value = fmt;
    }
    function selectOccurrence(_ref4) {
      var _occurrence$sector;
      var occurrence = _ref4.occurrence,
        timeslot = _ref4.timeslot;
      var ticketConfig = prepareTicketConfig(occurrence.ticketConfig, occurrence.organizerId);
      if (timeslot) {
        ticketConfig = timeslot.ticketConfig.map(function (tc) {
          return _objectSpread(_objectSpread({}, occurrence.ticketConfig.find(function (otc) {
            return otc.id === tc.id;
          })), tc);
        });
      }
      if (((_occurrence$sector = occurrence.sector) === null || _occurrence$sector === void 0 ? void 0 : _occurrence$sector.length) > 0) {
        var sortedSectors = sortByDisplayOrder(occurrence.sector);
        event.value.selectedSector = sortedSectors[0];
        preparedSectors.value = sortedSectors.map(function (s) {
          return {
            id: s.id,
            label: s.name,
            displayOrder: s.displayOrder,
            selected: false
          };
        });
        preparedSectors.value[0].selected = true;
      }
      event.value = _objectSpread(_objectSpread({}, event.value), {}, {
        ticketConfig: prepareTicketConfig(ticketConfig, event.value.organizerId)
      });
      selectedOccurrence.value = occurrence;
      selectedTimeslot.value = timeslot;
      stepReverse.value = false;
      stepTickets.value++;
      fetchOwnedTickets();
      if (selectedOccurrence.value.chartKey) {
        // so the same tickets aren't added multiple times by addSeat on repeat clicks
        clearTicketPreview();
        fetchSeats();
        fetchOwnedTickets();
      }
      trackMetaEvent('ViewContent', toOccurrenceClickEvent(selectedOccurrence.value), {
        eventID: Date.now().toString()
      });
      redirectIfNeeded(occurrence);
    }
    function showDialog(discount, access) {
      discountCode.value = discount;
      accessCode.value = access;
      dialog.value = true;
      if (isFormatSupported('secure') && isFormatSupported('pdf')) {
        format.value = null;
      } else if (isFormatSupported('secure')) {
        setTicketFormat(formats.SECURE);
      } else if (isFormatSupported('pdf')) {
        setTicketFormat(formats.PDF);
      }
    }
    function showDialogSM() {
      format.value = formats.SECURE;
      if (!auth.loggedIn) {
        dialog.value = null;
        openLogin();
      } else {
        buyTickets();
      }
    }
    function closeDialog() {
      dialog.value = false;
    }
    function fetchSeats() {
      var _organizer$value3;
      if ((_organizer$value3 = organizer.value) !== null && _organizer$value3 !== void 0 && _organizer$value3.workspaceKey) {
        workspaceKey = organizer.value.workspaceKey;
        try {
          // seatmap renders after occurrence/timeslot select when they exist,
          // otherwise on page render
          seatsioEventId.value = isRecurring.value || hasTimeslots.value ? String(selectedOccurrence.value.id) : String(event.value.id);
          renderSeatingChart();
          eventLoaded.value = true;
        } catch (e) {
          seatsioEventId.value = null;
          eventLoaded.value = true;
        }
      }
    }
    function discountIsUsable(discount) {
      return (discount === null || discount === void 0 ? void 0 : discount.availableTickets) >= (discount === null || discount === void 0 ? void 0 : discount.minQuantity);
    }
    function discountAvailable(discount) {
      var now = moment();
      return now.isSameOrAfter(moment(discount.startAt)) && now.isSameOrBefore(moment(discount.endAt));
    }
    function renderSeatingChart() {
      var _offers$value2;
      var ticketConfigs = isRecurring.value ? selectedOccurrence.value.ticketConfig : event.value.ticketConfig;
      var pricing = ticketConfigs.map(function (tc) {
        var ticketDiscounts = tc.ticketDiscount;
        var availableDiscounts = ticketDiscounts.filter(function (td) {
          return (td === null || td === void 0 ? void 0 : td.availableTickets) > 0 && discountIsUsable(td) && discountAvailable(td);
        });
        var ticketTypes = [{
          name: t('buyTickets.noDiscount')
        }].concat(_toConsumableArray(availableDiscounts));
        return {
          category: tc.name,
          ticketTypes: ticketTypes.map(function (discount) {
            var price = applyDiscount(discount, tc.faceValue);
            return {
              ticketType: String(discount.id),
              label: discount.name,
              price: price,
              market: 'PRIMARY'
            };
          })
        };
      });
      if (((_offers$value2 = offers.value) === null || _offers$value2 === void 0 ? void 0 : _offers$value2.length) > 0 && showSecondaryMarket.value) {
        var pricesSM = offers.value.map(function (offer) {
          return {
            objects: ["".concat(offer.seatId)],
            ticketTypes: [{
              price: offer.price,
              ticketType: String(offer.id),
              label: offer.ticketConfig.name,
              market: 'SECONDARY',
              extraData: {
                offerId: offer.id
              }
            }]
          };
        });
        pricing = [].concat(_toConsumableArray(pricing), _toConsumableArray(pricesSM));
      }
      var maxSelectedObjects = ticketConfigs.map(function (tc) {
        return {
          category: tc.name,
          quantity: Math.min(tc.ticketsPerUser, tc.availableTickets)
        };
      });
      var unavailableCategories = ticketConfigs.filter(function (tc) {
        return tc.ended || !tc.started;
      }).map(function (tc) {
        return tc.name;
      });
      var categoryFilter = {
        enabled: true,
        multiSelect: true,
        zoomOnSelect: false,
        sortBy: 'priceDescending'
      };
      var seatingChartConfig = {
        divId: 'chart',
        workspaceKey: workspaceKey,
        event: seatsioEventId.value,
        session: 'continue',
        language: nuxtApp.$i18n.locale,
        pricing: pricing,
        maxSelectedObjects: maxSelectedObjects,
        unavailableCategories: unavailableCategories,
        categoryFilter: categoryFilter,
        priceFormatter: function priceFormatter(price) {
          return price + ' ' + ticketConfigs[0].currency;
        },
        channels: ['NO_CHANNEL'],
        onObjectSelected: addSeat,
        onObjectDeselected: removeSeat,
        onChartRendered: function onChartRendered() {
          showSeatsOverlay.value = true;
        },
        onChartRenderingFailed: function onChartRenderingFailed(chart) {
          chart.destroy();
          seatsioEventId.value = null;
          // fallback to config without category filter — it doesn't work in all cases
          seatingChartConfig.categoryFilter.enabled = false;
          seatingChart = new window.seatsio.SeatingChart(seatingChartConfig).render();
        },
        selectionValidators: [{
          type: 'noOrphanSeats'
        }],
        onSelectionValid: function onSelectionValid() {
          seatSelectionValid.value = true;
        },
        onSelectionInvalid: function onSelectionInvalid() {
          seatSelectionValid.value = false;
          notifier.showMessage({
            title: t('seats.noOrphanError.title'),
            content: t('seats.noOrphanError.content'),
            type: 'error'
          });
        }
      };
      nextTick(function () {
        seatingChart = new window.seatsio.SeatingChart(seatingChartConfig).render();
      });
    }
    function addSeat(seat, ticketType) {
      if (ticketType.market === 'PRIMARY' && showSecondaryCart.value) {
        notifier.showMessage({
          content: t('buyTickets.mixedTickets.error'),
          type: 'error'
        });
        setTimeout(function () {
          seat.deselect(seat.selectedTicketType);
        }, 100);
        return;
      }
      if (ticketType.market === 'SECONDARY' && showPrimaryCart.value) {
        notifier.showMessage({
          content: t('buyTickets.mixedTickets.error'),
          type: 'error'
        });
        setTimeout(function () {
          seat.deselect(seat.selectedTicketType);
        }, 100);
        return;
      }
      if (ticketType.market === 'PRIMARY') {
        // handles the case when the user cancels the order
        if (orderExists.value) {
          var _selectedTickets$valu, _order$tickets;
          var order = getReducedOrder.value(eventId);
          var foundTicket = order.tickets.find(function (ticket) {
            return (ticket.ticketConfig.id === seat.category.key || ticket.ticketConfig.name === seat.category.key) && !selectedTickets.value.some(function (st) {
              return st.ticketId === ticket.id;
            });
          });
          if (foundTicket) {
            selectedTickets.value.push(_objectSpread(_objectSpread({}, adjustOrderTicketForCart(foundTicket)), {}, {
              seat: seat
            }));
          }
          if (((_selectedTickets$valu = selectedTickets.value) === null || _selectedTickets$valu === void 0 ? void 0 : _selectedTickets$valu.length) === ((_order$tickets = order.tickets) === null || _order$tickets === void 0 ? void 0 : _order$tickets.length)) {
            orderExists.value = false;
          }
          return;
        }
        event.value.ticketConfig.forEach(function (tc) {
          if (tc.id === seat.category.key || tc.name === seat.category.key) {
            if (!conditionalTicketingSatisfied(tc)) {
              ignoreNextDeselection = true;
              seat.deselect(seat.selectedTicketType);
              if (!auth.loggedIn) {
                openLogin();
                return;
              }
              notifier.showMessage({
                content: t('conditional.error.message', {
                  ticket: conditionalConfigText(tc)
                }),
                type: 'error'
              });
              return;
            }
            tc.discounts.forEach(function (discount) {
              if (String(discount.id) === ticketType.ticketType) {
                if (isDonation(tc.pricingType) && !donationDialog.value) {
                  donationAmount.value = null;
                  donationTicket.value = {
                    ticket: tc,
                    discount: discount,
                    seat: seat
                  };
                  showDonationDialog(true);
                  return;
                }
                var seatedTicket = _objectSpread(_objectSpread({}, tc), adjustTicketDataForCart(tc, discount, seat));
                selectedTickets.value.push(seatedTicket);
                gtmPush('add_to_cart', toAddToCartEvent(seatedTicket));
              }
            });
          }
        });
        showPrimaryCartForSeatedEvents.value = true;
      } else {
        var _foundTicket = ticketsSM.value.find(function (ticket) {
          return String(ticket.id) === ticketType.ticketType;
        });
        if (_foundTicket) {
          _foundTicket.seat = seat;
          selectedTicketsSM.value.push(_foundTicket);
        }
        showSecondaryCartForSeatedEvents.value = true;
      }
    }
    function removeSeat(seat) {
      if (ignoreNextDeselection) {
        ignoreNextDeselection = false;
        return;
      }
      if (showSecondaryCartForSeatedEvents.value) {
        var _index = selectedTicketsSM.value.map(function (x) {
          return x.seatId;
        }).indexOf(seat.id);
        if (_index >= 0) {
          selectedTicketsSM.value.splice(_index, 1);
        }
        return;
      }
      var index = selectedTickets.value.map(function (x) {
        var _x$seat;
        return (_x$seat = x.seat) === null || _x$seat === void 0 ? void 0 : _x$seat.id;
      }).indexOf(seat.id);
      if (index >= 0) {
        selectedTickets.value.splice(index, 1);
      }
    }
    function adjustTicketDataForCart(ticket, discount, seat) {
      var _selectedTimeslot$val2;
      var selectedTicket = _objectSpread({}, ticket);
      selectedTicket.sector = event.value.selectedSector;
      selectedTicket.finalPrice = isDonation(ticket.pricingType) ? donationAmount.value : discount === null || discount === void 0 ? void 0 : discount.finalPrice;
      selectedTicket.discount = discount !== null && discount !== void 0 && discount.id ? discount : undefined;
      selectedTicket.fees = discount === null || discount === void 0 ? void 0 : discount.fees;
      selectedTicket.seat = seat;
      if (isRecurring.value) {
        selectedTicket.occurrenceId = selectedOccurrence.value.id;
        selectedTicket.occurrenceName = selectedOccurrence.value.name;
        selectedTicket.occurrenceStartAt = selectedOccurrence.value.startAt;
        selectedTicket.occurrenceEndAt = selectedOccurrence.value.endAt;
      }
      if ((_selectedTimeslot$val2 = selectedTimeslot.value) !== null && _selectedTimeslot$val2 !== void 0 && _selectedTimeslot$val2.id) {
        selectedTicket.timeslotId = selectedTimeslot.value.id;
        selectedTicket.timeslotName = selectedTimeslot.value.name;
        selectedTicket.timeslotStartAt = selectedTimeslot.value.startAt;
        selectedTicket.timeslotEndAt = selectedTimeslot.value.endAt;
      }
      return selectedTicket;
    }
    function addTicket(_x3) {
      return _addTicket.apply(this, arguments);
    }
    function _addTicket() {
      _addTicket = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref5) {
        var ticket, discount, seat, valid, selectedTicket, foundTicketConfig, foundDiscount;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              ticket = _ref5.ticket, discount = _ref5.discount, seat = _ref5.seat;
              _context6.next = 1;
              return observer.value.validate();
            case 1:
              valid = _context6.sent;
              if (valid) {
                _context6.next = 2;
                break;
              }
              notifier.showMessage({
                content: t('errors.fixForm'),
                type: 'error'
              });
              window.scrollTo(0, 0);
              return _context6.abrupt("return");
            case 2:
              if (!(isDonation(ticket.pricingType) && !donationDialog.value)) {
                _context6.next = 3;
                break;
              }
              donationAmount.value = null;
              donationTicket.value = {
                ticket: ticket,
                discount: discount
              };
              showDonationDialog(true);
              return _context6.abrupt("return");
            case 3:
              if (donationTicket.value) {
                ticket.donationAmount = donationAmount.value;
              }
              if (isMobile.value && donationDialog.value) {
                openMobileCart();
              }
              showDonationDialog(false);
              selectedTicket = _objectSpread(_objectSpread({}, ticket), adjustTicketDataForCart(ticket, discount, seat));
              foundTicketConfig = findTicketConfig(ticket.id, ticket.occurrenceId);
              foundTicketConfig.availableTickets--;
              foundTicketConfig.amountOfTicketInCart++;
              foundDiscount = findDiscount(discount.id);
              if ((foundDiscount === null || foundDiscount === void 0 ? void 0 : foundDiscount.availableTickets) !== undefined) {
                foundDiscount.availableTickets--;
              }
              discount.selectedQuantity++;
              selectedTickets.value.push(selectedTicket);
              gtmPush('add_to_cart', toAddToCartEvent(selectedTicket));
              donationTicket.value = null;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return _addTicket.apply(this, arguments);
    }
    function addTicketSM(ticket) {
      selectedTicketsSM.value.push(ticket);
      ticketsSM.value = ticketsSM.value.filter(function (t) {
        return t.id !== ticket.id;
      });
    }
    function removeTicket(_ref6) {
      var ticket = _ref6.ticket,
        discount = _ref6.discount;
      ticket.sector = event.value.selectedSector;
      discount.selectedQuantity--;
      var foundTicketConfig = findTicketConfig(ticket.id, ticket.occurrenceId);
      foundTicketConfig.availableTickets++;
      foundTicketConfig.amountOfTicketInCart--;
      for (var i = 0; i < selectedTickets.value.length; i++) {
        var _tkt$sector, _ticket$sector, _tkt$discount;
        var tkt = selectedTickets.value[i];
        if ((tkt === null || tkt === void 0 ? void 0 : (_tkt$sector = tkt.sector) === null || _tkt$sector === void 0 ? void 0 : _tkt$sector.id) === (ticket === null || ticket === void 0 ? void 0 : (_ticket$sector = ticket.sector) === null || _ticket$sector === void 0 ? void 0 : _ticket$sector.id) && (discount !== null && discount !== void 0 && discount.id ? ((_tkt$discount = tkt.discount) === null || _tkt$discount === void 0 ? void 0 : _tkt$discount.id) === discount.id : tkt.discount === undefined) && tkt.id === ticket.id) {
          selectedTickets.value.splice(i, 1);
          break;
        }
      }
      var foundDiscount = findDiscount(discount.id);
      if ((foundDiscount === null || foundDiscount === void 0 ? void 0 : foundDiscount.availableTickets) !== undefined) {
        foundDiscount.availableTickets++;
      }
    }
    function removeTicketPreview(_x4) {
      return _removeTicketPreview.apply(this, arguments);
    }
    function _removeTicketPreview() {
      _removeTicketPreview = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7) {
        var ticket, index, foundTicketConfig, seat;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              ticket = _ref7.ticket, index = _ref7.index;
              foundTicketConfig = findTicketConfig(ticket.id, ticket.occurrenceId);
              foundTicketConfig.availableTickets++;
              foundTicketConfig.amountOfTicketInCart--;
              seat = selectedTickets.value[index].seat;
              if (!seat) {
                _context7.next = 2;
                break;
              }
              _context7.next = 1;
              return seat.deselect(seat.selectedTicketType);
            case 1:
              _context7.next = 3;
              break;
            case 2:
              selectedTickets.value.splice(index, 1);
            case 3:
              recalculateDiscountQuantity(ticket);
              if (seatingChart) {
                // reserved seats can stay reserved on the UI when switching seat modes
                seatingChart.resetView();
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return _removeTicketPreview.apply(this, arguments);
    }
    function clearTicketPreview() {
      var deselectSeats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      while (selectedTickets.value.length > 0) {
        var ticket = selectedTickets.value.shift();
        var foundTicketConfig = findTicketConfig(ticket.id, ticket.occurrenceId);
        foundTicketConfig.availableTickets++;
        foundTicketConfig.amountOfTicketInCart--;
        var seat = ticket.seat;
        if (seat && deselectSeats) {
          seat.deselect(seat.selectedTicketType);
        }
        recalculateDiscountQuantity(ticket);
      }
    }
    function recalculateDiscountQuantity(ticket) {
      var foundDiscount;
      var _iterator = _createForOfIteratorHelper(event.value.ticketConfig),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ticketConfig = _step.value;
          if (ticketConfig.id !== ticket.id) continue;
          var _iterator2 = _createForOfIteratorHelper(ticketConfig.discounts),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _ticket$discount, _foundDiscount;
              var discount = _step2.value;
              if ((discount === null || discount === void 0 ? void 0 : discount.id) !== ((_ticket$discount = ticket.discount) === null || _ticket$discount === void 0 ? void 0 : _ticket$discount.id)) continue;
              foundDiscount = findDiscount(discount.id);
              discount.selectedQuantity--;
              if (((_foundDiscount = foundDiscount) === null || _foundDiscount === void 0 ? void 0 : _foundDiscount.availableTickets) !== undefined) {
                foundDiscount.availableTickets++;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    function removeTicketPreviewSM(_x5) {
      return _removeTicketPreviewSM.apply(this, arguments);
    }
    function _removeTicketPreviewSM() {
      _removeTicketPreviewSM = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref8) {
        var ticket, index, seat;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              ticket = _ref8.ticket, index = _ref8.index;
              ticketsSM.value.push(selectedTicketsSM.value[index]);
              if (!(selectedTicketsSM.value[index].seat !== '-')) {
                _context8.next = 3;
                break;
              }
              seat = selectedTicketsSM.value[index].seat;
              if (!seat) {
                _context8.next = 2;
                break;
              }
              _context8.next = 1;
              return seat.deselect(seat.selectedTicketType);
            case 1:
              _context8.next = 3;
              break;
            case 2:
              selectedTicketsSM.value.splice(index, 1);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return _removeTicketPreviewSM.apply(this, arguments);
    }
    function getOrganizer() {
      return _getOrganizer.apply(this, arguments);
    }
    function _getOrganizer() {
      _getOrganizer = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _event$value14, _organizer$value4, _organizer$value5, _t4;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 1;
              return sdk.account.getOrganizer({
                id: (_event$value14 = event.value) === null || _event$value14 === void 0 ? void 0 : _event$value14.organizerId,
                // 'workspaceKey' is what the API accepts here; the SDK's field-name union
                // is stricter than the runtime.
                fields: ['workspaceKey', 'branding', 'payment_providers']
              });
            case 1:
              organizer.value = _context9.sent;
              if ((_organizer$value4 = organizer.value) !== null && _organizer$value4 !== void 0 && _organizer$value4.url && !((_organizer$value5 = organizer.value) !== null && _organizer$value5 !== void 0 && _organizer$value5.url.includes('://'))) {
                organizer.value.url = '//' + organizer.value.url;
              }
              _context9.next = 3;
              break;
            case 2:
              _context9.prev = 2;
              _t4 = _context9["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t4, t('errors.fetchOrganizerInfo')),
                type: 'error'
              });
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 2]]);
      }));
      return _getOrganizer.apply(this, arguments);
    }
    function getVenue() {
      return _getVenue.apply(this, arguments);
    }
    function _getVenue() {
      _getVenue = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var _e$response, _e$response$data, _t5, _t6, _t7, _t8, _t9;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              if (!event.value.venueId) {
                _context0.next = 2;
                break;
              }
              _t5 = _objectSpread;
              _t6 = _objectSpread({}, event.value);
              _t7 = {};
              _context0.next = 1;
              return sdk.venue.getVenue({
                id: event.value.venueId
              });
            case 1:
              _t8 = _context0.sent;
              event.value = _t5(_t6, _t7, {
                venue: _t8
              });
            case 2:
              if (!isRecurring.value) {
                _context0.next = 4;
                break;
              }
              _context0.next = 3;
              return assignVenuesToOccurrences(event.value.occurrence);
            case 3:
              event.value.occurrence = _context0.sent;
            case 4:
              _context0.next = 6;
              break;
            case 5:
              _context0.prev = 5;
              _t9 = _context0["catch"](0);
              notifier.showMessage({
                content: (_t9 === null || _t9 === void 0 ? void 0 : (_e$response = _t9.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.message) || t('errors.fetchEvent'),
                type: 'error'
              });
            case 6:
            case "end":
              return _context0.stop();
          }
        }, _callee0, null, [[0, 5]]);
      }));
      return _getVenue.apply(this, arguments);
    }
    function getEvent() {
      return _getEvent.apply(this, arguments);
    }
    function _getEvent() {
      _getEvent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var _event$value15, _event$value15$sector, evt, sortedSectors, _e$response2, _e$response2$data, _t0;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              _context1.next = 1;
              return fetchEvent();
            case 1:
              evt = _context1.sent;
              populateCart(evt.type);
              if (evt.type === eventTypes.SINGLE) {
                evt.ticketConfig = prepareTicketConfig(evt.ticketConfig, evt.organizerId);
                evt.occurrence = [_objectSpread(_objectSpread({}, evt), calculatePriceRange(evt.ticketConfig))];
              } else {
                evt.occurrence = evt.occurrence.map(function (occurrence) {
                  var tc = prepareTicketConfig(occurrence.ticketConfig, occurrence.organizerId);
                  return _objectSpread(_objectSpread(_objectSpread({}, occurrence), calculatePriceRange(tc)), {}, {
                    ticketConfig: occurrence.ticketConfig.filter(function (t) {
                      return t.visible;
                    })
                  });
                });
                adjustRecurringEventDates(evt);
              }
              event.value = evt;
              event.value.timezone = getTimezoneFromName(evt.startAt, evt.timezoneName);
              if (((_event$value15 = event.value) === null || _event$value15 === void 0 ? void 0 : (_event$value15$sector = _event$value15.sector) === null || _event$value15$sector === void 0 ? void 0 : _event$value15$sector.length) > 0) {
                sortedSectors = sortByDisplayOrder(event.value.sector);
                event.value.selectedSector = sortedSectors[0];
                preparedSectors.value = sortedSectors.map(function (s) {
                  return {
                    id: s.id,
                    label: s.name,
                    displayOrder: s.displayOrder,
                    selected: false
                  };
                });
                preparedSectors.value[0].selected = true;
              }
              originalEventData.value = clone(event.value);
              _context1.next = 3;
              break;
            case 2:
              _context1.prev = 2;
              _t0 = _context1["catch"](0);
              notifier.showMessage({
                content: (_t0 === null || _t0 === void 0 ? void 0 : (_e$response2 = _t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.message) || t('errors.fetchEvent'),
                type: 'error'
              });
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee1, null, [[0, 2]]);
      }));
      return _getEvent.apply(this, arguments);
    }
    function fetchEvent() {
      return _fetchEvent.apply(this, arguments);
    }
    /** Redirects to `event.redirectUrl` if set — useful for pointing to new occurrences. */
    function _fetchEvent() {
      _fetchEvent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var accessToken, withQuery;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              accessToken = route.query.acc_token;
              _context10.next = 1;
              return sdk.useOrganizer(tenant);
            case 1:
              if (featureFlags.showTickets) {
                withQuery = {
                  subcategory: true,
                  sector: {
                    ticket_config: {
                      ticket_discount: true
                    }
                  },
                  ticket_discount: true,
                  ticket_config: {
                    ticket_discount: true,
                    depends_on: true
                  },
                  occurrence: {
                    ticket_config: {
                      ticket_discount: true,
                      depends_on: true
                    },
                    timeslot: {
                      ticket_config: true
                    },
                    sector: {
                      ticket_config: true
                    }
                  },
                  timeslot: {
                    ticket_config: true
                  },
                  ticket_format: true
                };
              } else {
                withQuery = {
                  subcategory: true
                };
              }
              if (!accessToken) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return", sdk.event.getPrivateEvent({
                // route params/query are strings; these SDK ids are typed `number` but
                // the API takes the string id (unchanged from the pre-migration JS).
                id: eventId,
                access_token: accessToken,
                with: withQuery
              }));
            case 2:
              return _context10.abrupt("return", sdk.event.getEvent({
                id: eventId,
                with: withQuery
              }));
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return _fetchEvent.apply(this, arguments);
    }
    function redirectIfNeeded(evt) {
      if (isValidHttpUrl(evt === null || evt === void 0 ? void 0 : evt.redirectUrl)) {
        window.location.href = evt.redirectUrl;
      }
    }
    function getSecondaryTickets() {
      return _getSecondaryTickets.apply(this, arguments);
    }
    /** Parses and formats ticket config list for cart */
    function _getSecondaryTickets() {
      _getSecondaryTickets = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var list, _t1;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 1;
              return sdk.orderbook.listOffers({
                event_id: eventId
              });
            case 1:
              list = _context11.sent;
              list.forEach(function (offer) {
                var _event$value16, _event$value16$ticket;
                var offerTicketConfig = (_event$value16 = event.value) === null || _event$value16 === void 0 ? void 0 : (_event$value16$ticket = _event$value16.ticketConfig) === null || _event$value16$ticket === void 0 ? void 0 : _event$value16$ticket.find(function (tc) {
                  return tc.id === offer.ticketConfigId;
                });
                if (offerTicketConfig) {
                  var _offer$seatId;
                  var offerName = offerTicketConfig === null || offerTicketConfig === void 0 ? void 0 : offerTicketConfig.name;
                  offer.ticketConfig = offerTicketConfig;
                  ticketsSM.value.push(_objectSpread(_objectSpread({}, offer), {}, {
                    name: offerName,
                    seat: (_offer$seatId = offer.seatId) !== null && _offer$seatId !== void 0 ? _offer$seatId : '-',
                    finalPrice: offer.price
                  }));
                }
              });
              offers.value = list;
              _context11.next = 3;
              break;
            case 2:
              _context11.prev = 2;
              _t1 = _context11["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t1, t('errors.genericRequest')),
                type: 'error'
              });
            case 3:
              loading.value = false;
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 2]]);
      }));
      return _getSecondaryTickets.apply(this, arguments);
    }
    function prepareTicketConfig(ticketConfig, organizerArg) {
      var now = moment();
      var isOnSiteSellerFlag = isOnSiteSeller.value(organizerArg);
      return ticketConfig === null || ticketConfig === void 0 ? void 0 : ticketConfig.sort(function (tA, tB) {
        if (isOnSiteSellerFlag) {
          return (tB === null || tB === void 0 ? void 0 : tB.onSiteSale) - (tA === null || tA === void 0 ? void 0 : tA.onSiteSale);
        }
        return (tA === null || tA === void 0 ? void 0 : tA.id) - (tB === null || tB === void 0 ? void 0 : tB.id);
      }).map(function (tc) {
        if (tc.startSaleAt) {
          tc.started = moment(tc.startSaleAt).isBefore(now);
        }
        if (tc.endSaleAt) {
          tc.ended = moment(tc.endSaleAt).isBefore(now);
        }
        var ticketConfigsInCart = selectedTickets.value.filter(function (t) {
          return (t === null || t === void 0 ? void 0 : t.id) === tc.id;
        });
        var tcDiscounts = [{
          name: t('buyTickets.noDiscount')
        }].concat(_toConsumableArray(tc === null || tc === void 0 ? void 0 : tc.ticketDiscount)).map(function (discount) {
          var finalPrice = tc.faceValue;
          if (discount !== null && discount !== void 0 && discount.id) {
            finalPrice = applyDiscount(discount, finalPrice);
          }
          var numberOfDiscountsApplied = ticketConfigsInCart.filter(function (t) {
            var _t$ticketDiscount$;
            return (t === null || t === void 0 ? void 0 : (_t$ticketDiscount$ = t.ticketDiscount[0]) === null || _t$ticketDiscount$ === void 0 ? void 0 : _t$ticketDiscount$.id) === discount.id;
          }).length;
          return _objectSpread(_objectSpread({}, discount), {}, {
            finalPrice: finalPrice,
            fees: 0,
            selectedQuantity: numberOfDiscountsApplied
          });
        });
        var numberOfTicketConfigsInCart = ticketConfigsInCart.length;
        return _objectSpread(_objectSpread({}, tc), {}, {
          amountOfTicketInCart: numberOfTicketConfigsInCart,
          availableTickets: Math.max(tc.availableTickets - numberOfTicketConfigsInCart, 0),
          discount: tcDiscounts[0],
          discounts: tcDiscounts
        });
      });
    }
    /** Open a websocket to listen for wallet qr code scanning to identify wallet */
    function openWebSocket(channel, secret) {
      try {
        var url = "wss://".concat(tenant, ".").concat(runtimeConfig.apiBaseUrl, "/websocket/adhoc/").concat(channel, "/").concat(secret);
        var client = new WebSocket(url);
        client.onmessage = function (ev) {
          var reader = new FileReader();
          reader.onloadend = function () {
            try {
              var response = JSON.parse(reader.result);
              dialog.value = null;
              sdk.authorize(new JwtCredentials(response));
              createOrder();
            } catch (e) {
              notifier.showMessage({
                content: t('errors.publishEvent'),
                type: 'error'
              });
            }
          };
          reader.readAsText(ev.data);
        };
      } catch (e) {
        notifier.showMessage({
          content: t('errors.publishEvent'),
          type: 'error'
        });
      }
    }
    /** Gets QR code data needed to continue with wallet login */
    function getQrCode() {
      return _getQrCode.apply(this, arguments);
    }
    function _getQrCode() {
      _getQrCode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var secret, response, _e$response3, _t10;
        return regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              secret = uuid();
              _context12.next = 1;
              return services.account.identifyWallet(secret, tenant);
            case 1:
              response = _context12.sent;
              if (response !== null && response !== void 0 && response.code) {
                qrcodeImage.value = response.code;
                dialog.value = null;
                openLogin();
                openWebSocket(response.channel, secret);
              } else {
                dialog.value = false;
                notifier.showMessage({
                  content: t('errors.fetchEvent'),
                  type: 'error'
                });
              }
              _context12.next = 3;
              break;
            case 2:
              _context12.prev = 2;
              _t10 = _context12["catch"](0);
              dialog.value = false;
              if ((_t10 === null || _t10 === void 0 ? void 0 : (_e$response3 = _t10.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.status) === 401) {
                notifier.showMessage({
                  content: t('errors.editEventPermissions'),
                  type: 'error'
                });
                router.replace(localePath('/'));
              } else {
                notifier.showMessage({
                  content: t('errors.fetchEvent'),
                  type: 'error'
                });
              }
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 2]]);
      }));
      return _getQrCode.apply(this, arguments);
    }
    function checkUserType(selectedTicketFormat) {
      setTicketFormat(selectedTicketFormat);
      if (auth.loggedIn) {
        fetchOwnedTickets();
        createOrder();
      } else {
        dialog.value = null;
        openLogin();
      }
    }
    function buyTickets() {
      return _buyTickets.apply(this, arguments);
    }
    function _buyTickets() {
      _buyTickets = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(selectedTickets.value.length > 0)) {
                _context13.next = 2;
                break;
              }
              _context13.next = 1;
              return createOrder();
            case 1:
              _context13.next = 3;
              break;
            case 2:
              _context13.next = 3;
              return createSMOrder();
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return _buyTickets.apply(this, arguments);
    }
    function createSMOrder() {
      return _createSMOrder.apply(this, arguments);
    }
    /**
     * Reduces tickets from the cart & returns reduced order items — merges tickets
     * of the same type so a config appears once with an increased quantity and
     * merged seat ids.
     */
    function _createSMOrder() {
      _createSMOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var _auth$user;
        var offerData, res, _t11;
        return regeneratorRuntime.wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              dialog.value = null;
              if (auth !== null && auth !== void 0 && (_auth$user = auth.user) !== null && _auth$user !== void 0 && _auth$user.enrollmentId) {
                _context14.next = 1;
                break;
              }
              notifier.showMessage({
                content: t('errors.purchaseNotEnrolled'),
                type: 'error'
              });
              return _context14.abrupt("return");
            case 1:
              _context14.prev = 1;
              offerData = {
                offers: selectedTicketsSM.value.map(function (selectedTicket) {
                  return selectedTicket.id;
                })
              };
              if (isGlobalPayments.value) {
                offerData = _objectSpread(_objectSpread({}, offerData), {}, {
                  paymentProvider: 'global-payments',
                  redirectUrl: "".concat(window.location.origin, "/").concat(tenant, "/event/").concat(eventId, "/confirm")
                });
              }
              _context14.next = 2;
              return sdk.orderbook.createOrder(offerData);
            case 2:
              res = _context14.sent;
              ordersStore.addOrder({
                orderData: res,
                market: 'secondary',
                eventId: event.value.id,
                orderId: res.order.id,
                orderTimeout: moment().add(30, 'minutes')
              });
              router.push(localePath("/".concat(tenant, "/event/").concat(event.value.id, "/confirm")));
              _context14.next = 4;
              break;
            case 3:
              _context14.prev = 3;
              _t11 = _context14["catch"](1);
              notifier.showMessage({
                content: errorMessage(_t11, t('errors.genericRequest')),
                type: 'error'
              });
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[1, 3]]);
      }));
      return _createSMOrder.apply(this, arguments);
    }
    function createOrderItems() {
      return selectedTickets.value.reduce(function (reducedTickets, ticket) {
        var exist = false;
        reducedTickets.forEach(function (t) {
          var _t$ticketDiscount, _ticket$discount2, _ticket$sector2;
          if (t.ticketConfigId === ticket.id && ((_t$ticketDiscount = t.ticketDiscount) === null || _t$ticketDiscount === void 0 ? void 0 : _t$ticketDiscount[0]) === ((_ticket$discount2 = ticket.discount) === null || _ticket$discount2 === void 0 ? void 0 : _ticket$discount2.id) && t.sectorId === ((_ticket$sector2 = ticket.sector) === null || _ticket$sector2 === void 0 ? void 0 : _ticket$sector2.id) && t.timeslotId === (ticket === null || ticket === void 0 ? void 0 : ticket.timeslotId) && t.kycLevelId === ticket.kycLevelId && (!ticket.donationAmount || t.finalPrice === ticket.finalPrice)) {
            exist = true;
            t.quantity++;
            if (ticket.seat) {
              t.selectedSeats.push(ticket.seat.id);
            }
          }
        });
        if (!exist) {
          var _ticket$discount3, _ticket$seat;
          var orderItem = {
            ticketConfigId: ticket.id,
            quantity: 1,
            ticketDiscount: ticket.discount ? [(_ticket$discount3 = ticket.discount) === null || _ticket$discount3 === void 0 ? void 0 : _ticket$discount3.id] : undefined,
            sectorId: ticket.sector ? ticket.sector.id : undefined,
            timeslotId: ticket === null || ticket === void 0 ? void 0 : ticket.timeslotId,
            kycLevelId: ticket === null || ticket === void 0 ? void 0 : ticket.kycLevelId,
            occurrenceId: ticket === null || ticket === void 0 ? void 0 : ticket.occurrenceId,
            occurrenceName: ticket === null || ticket === void 0 ? void 0 : ticket.occurrenceName,
            occurrenceStartAt: ticket === null || ticket === void 0 ? void 0 : ticket.occurrenceStartAt,
            occurrenceEndAt: ticket === null || ticket === void 0 ? void 0 : ticket.occurrenceEndAt,
            seatId: ticket === null || ticket === void 0 ? void 0 : (_ticket$seat = ticket.seat) === null || _ticket$seat === void 0 ? void 0 : _ticket$seat.id
          };
          if (ticket.seat) {
            orderItem.selectedSeats = [ticket.seat.id];
          }
          if (ticket.donationAmount) {
            orderItem.selectedPrice = ticket.donationAmount;
          }
          reducedTickets.push(orderItem);
        }
        return reducedTickets;
      }, []);
    }
    /**
     * Creates order data for the POST call, persists it in local store,
     * and routes to holders (if KYC) or confirm.
     */
    function createOrder() {
      return _createOrder.apply(this, arguments);
    }
    function _createOrder() {
      _createOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var _auth$user2, _auth$user3, _seatingChart2, createOrderData, referralCode, res, storeOrderData, query, _t12;
        return regeneratorRuntime.wrap(function (_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              appStore.setLoading(true);
              _context15.prev = 1;
              dialog.value = null;
              if (!(!(auth !== null && auth !== void 0 && (_auth$user2 = auth.user) !== null && _auth$user2 !== void 0 && _auth$user2.enrollmentId) && !((_auth$user3 = auth.user) !== null && _auth$user3 !== void 0 && _auth$user3.guestId))) {
                _context15.next = 2;
                break;
              }
              notifier.showMessage({
                content: t('errors.purchaseNotEnrolled'),
                type: 'error'
              });
              return _context15.abrupt("return");
            case 2:
              createOrderData = {
                orderItem: createOrderItems(),
                format: format.value,
                holdToken: (_seatingChart2 = seatingChart) === null || _seatingChart2 === void 0 ? void 0 : _seatingChart2.holdToken
              };
              if (discountCode.value) {
                createOrderData.discountCode = discountCode.value;
              }
              if (accessCode.value) {
                createOrderData.accessCode = accessCode.value;
              }
              referralCode = sessionStorage.getItem('referralCode');
              if (referralCode) {
                createOrderData.referralCode = referralCode;
              }
              _context15.next = 3;
              return sdk.order.createOrder(createOrderData);
            case 3:
              res = _context15.sent;
              trackMetaEvent('InitiateCheckout', toInitiateCheckoutEvent(res));
              gtmPush('begin_checkout', toBeginCheckoutEvent(res));
              storeOrderData = _objectSpread(_objectSpread({}, res), {}, {
                orderItem: res.orderItem.map(function (oi) {
                  return _objectSpread(_objectSpread({}, oi), {}, {
                    ticket: oi.ticket.map(function (ticket) {
                      var ticketInOrderCreationPayload = createOrderData.orderItem.find(function (o) {
                        return o.ticketConfigId === ticket.ticketConfig.id;
                      });
                      return _objectSpread(_objectSpread({}, ticket), {}, {
                        occurrenceId: ticketInOrderCreationPayload === null || ticketInOrderCreationPayload === void 0 ? void 0 : ticketInOrderCreationPayload.occurrenceId,
                        occurrenceName: ticketInOrderCreationPayload === null || ticketInOrderCreationPayload === void 0 ? void 0 : ticketInOrderCreationPayload.occurrenceName,
                        occurrenceStartAt: ticketInOrderCreationPayload === null || ticketInOrderCreationPayload === void 0 ? void 0 : ticketInOrderCreationPayload.occurrenceStartAt,
                        occurrenceEndAt: ticketInOrderCreationPayload === null || ticketInOrderCreationPayload === void 0 ? void 0 : ticketInOrderCreationPayload.occurrenceEndAt
                      });
                    })
                  });
                })
              });
              ordersStore.addOrder({
                orderData: storeOrderData,
                market: 'primary',
                eventId: event.value.id,
                orderId: res.id,
                orderTimeout: moment().add(30, 'minutes')
              });
              query = route.query;
              if (createOrderData.orderItem.some(function (oi) {
                return oi.kycLevelId !== KYC_LEVELS.NOT_REQUIRED;
              })) {
                router.push({
                  path: localePath("/".concat(tenant, "/event/").concat(event.value.id, "/holders")),
                  query: query
                });
              } else {
                router.push({
                  path: localePath("/".concat(tenant, "/event/").concat(event.value.id, "/confirm")),
                  query: query
                });
              }
              _context15.next = 5;
              break;
            case 4:
              _context15.prev = 4;
              _t12 = _context15["catch"](1);
              notifier.showMessage({
                content: errorMessage(_t12, t('errors.genericRequest')),
                type: 'error'
              });
            case 5:
              _context15.prev = 5;
              appStore.setLoading(false);
              return _context15.finish(5);
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[1, 4, 5, 6]]);
      }));
      return _createOrder.apply(this, arguments);
    }
    function fetchOwnedTickets() {
      return _fetchOwnedTickets.apply(this, arguments);
    }
    function _fetchOwnedTickets() {
      _fetchOwnedTickets = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function (_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!(hasConditionalTickets.value && auth.loggedIn)) {
                _context16.next = 2;
                break;
              }
              _context16.next = 1;
              return sdk.ticket.getTickets({
                with: {
                  ticket_config: {
                    depends_on: true
                  }
                }
              });
            case 1:
              ownedTickets.value = _context16.sent;
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      return _fetchOwnedTickets.apply(this, arguments);
    }
    return {
      __sfc: true,
      SelectSeatsModes: SelectSeatsModes,
      instance: instance,
      route: route,
      router: router,
      localePath: localePath,
      appStore: appStore,
      userStore: userStore,
      ordersStore: ordersStore,
      sdk: sdk,
      services: services,
      notifier: notifier,
      auth: auth,
      whitelabel: whitelabel,
      runtimeConfig: runtimeConfig,
      nuxtApp: nuxtApp,
      t: t,
      xsOnly: xsOnly,
      mdAndDown: mdAndDown,
      setupGtm: setupGtm,
      gtmPush: gtmPush,
      setupMetaPixel: setupMetaPixel,
      disableMetaPixel: disableMetaPixel,
      trackMetaEvent: trackMetaEvent,
      featureFlags: featureFlags,
      bus: bus,
      eventTypes: eventTypes,
      tabName: tabName,
      formats: formats,
      minDonationAmount: minDonationAmount,
      maxDonationAmount: maxDonationAmount,
      defaultPaymentProvider: defaultPaymentProvider,
      radioButtonOptions: radioButtonOptions,
      tenant: tenant,
      eventId: eventId,
      validator: validator,
      seatingChart: seatingChart,
      workspaceKey: workspaceKey,
      ignoreNextDeselection: ignoreNextDeselection,
      observer: observer,
      stepReverse: stepReverse,
      sectorMapLoaded: sectorMapLoaded,
      donationDialog: donationDialog,
      donationTicket: donationTicket,
      donationAmount: donationAmount,
      mobileCartVisible: mobileCartVisible,
      currentTab: currentTab,
      loading: loading,
      event: event,
      originalEventData: originalEventData,
      discountCode: discountCode,
      offers: offers,
      showSeatsOverlay: showSeatsOverlay,
      seatsioEventId: seatsioEventId,
      eventLoaded: eventLoaded,
      stepTickets: stepTickets,
      organizer: organizer,
      tickets: tickets,
      selectedTickets: selectedTickets,
      selectedTicketsSM: selectedTicketsSM,
      ticketsSM: ticketsSM,
      errorDialog: errorDialog,
      dialog: dialog,
      qrcodeImage: qrcodeImage,
      format: format,
      selectedTimeslot: selectedTimeslot,
      selectedOccurrence: selectedOccurrence,
      selectedDateRange: selectedDateRange,
      imageScale: imageScale,
      hideBottomText: hideBottomText,
      sectorMap: sectorMap,
      datePickerClicks: datePickerClicks,
      preparedSectors: preparedSectors,
      config: config,
      openCart: openCart,
      openSecondaryCart: openSecondaryCart,
      ownedTickets: ownedTickets,
      seatSelectionValid: seatSelectionValid,
      orderExists: orderExists,
      discountCodeValue: discountCodeValue,
      prefillTicketConfigId: prefillTicketConfigId,
      showPrimaryCartForSeatedEvents: showPrimaryCartForSeatedEvents,
      showSecondaryCartForSeatedEvents: showSecondaryCartForSeatedEvents,
      accessCode: accessCode,
      selectSeatsMode: selectSeatsMode,
      getReducedOrder: getReducedOrder,
      getLoading: getLoading,
      getAuthDialog: getAuthDialog,
      isOnSiteSeller: isOnSiteSeller,
      showPrimaryCart: showPrimaryCart,
      showSecondaryCart: showSecondaryCart,
      mainImageUri: mainImageUri,
      showSecondaryMarket: showSecondaryMarket,
      tabs: tabs,
      total: total,
      numberOfTickets: numberOfTickets,
      currency: currency,
      isRecurring: isRecurring,
      cartDisabled: cartDisabled,
      subcategory: subcategory,
      hasSectors: hasSectors,
      hasTimeslots: hasTimeslots,
      hasConditionalTickets: hasConditionalTickets,
      priceListKey: priceListKey,
      showDateTimePicker: showDateTimePicker,
      datePickerStep: datePickerStep,
      isMobile: isMobile,
      isSmallDevice: isSmallDevice,
      venue: venue,
      filteredDates: filteredDates,
      hasFilteredEvents: hasFilteredEvents,
      showEvent: showEvent,
      selectionValid: selectionValid,
      isSeatedEvent: isSeatedEvent,
      eventHasPassed: eventHasPassed,
      eventInPresale: eventInPresale,
      showSeatmap: showSeatmap,
      isGlobalPayments: isGlobalPayments,
      onSiteSaleOnlyEvent: onSiteSaleOnlyEvent,
      conditionalTicketingSatisfied: conditionalTicketingSatisfied,
      handleTicketConfigPrefill: handleTicketConfigPrefill,
      handleOccurrenceLink: handleOccurrenceLink,
      adjustOrderTicketForCart: adjustOrderTicketForCart,
      populateCart: populateCart,
      adjustRecurringEventDates: adjustRecurringEventDates,
      assignVenuesToOccurrences: assignVenuesToOccurrences,
      configIsConditional: configIsConditional,
      conditionalConfigText: conditionalConfigText,
      isDonation: isDonation,
      showDonationDialog: showDonationDialog,
      openMobileCart: openMobileCart,
      closeMobileCart: closeMobileCart,
      clearMobileCart: clearMobileCart,
      removeFromMobileCart: removeFromMobileCart,
      submitOrder: submitOrder,
      closeAuthDialog: closeAuthDialog,
      openLogin: openLogin,
      onLogin: onLogin,
      preparedTicketConfigs: preparedTicketConfigs,
      findDiscount: findDiscount,
      findPreparedTicketConfig: findPreparedTicketConfig,
      findOriginalTicketConfig: findOriginalTicketConfig,
      findTicketConfig: findTicketConfig,
      selectSector: selectSector,
      goBackToOccurrences: goBackToOccurrences,
      openWarningDialog: openWarningDialog,
      goToPreviousTab: goToPreviousTab,
      clearCartAndCloseDialog: clearCartAndCloseDialog,
      showSectorMap: showSectorMap,
      isFormatSupported: isFormatSupported,
      setTicketFormat: setTicketFormat,
      selectOccurrence: selectOccurrence,
      showDialog: showDialog,
      showDialogSM: showDialogSM,
      closeDialog: closeDialog,
      fetchSeats: fetchSeats,
      discountIsUsable: discountIsUsable,
      discountAvailable: discountAvailable,
      renderSeatingChart: renderSeatingChart,
      addSeat: addSeat,
      removeSeat: removeSeat,
      adjustTicketDataForCart: adjustTicketDataForCart,
      addTicket: addTicket,
      addTicketSM: addTicketSM,
      removeTicket: removeTicket,
      removeTicketPreview: removeTicketPreview,
      clearTicketPreview: clearTicketPreview,
      recalculateDiscountQuantity: recalculateDiscountQuantity,
      removeTicketPreviewSM: removeTicketPreviewSM,
      getOrganizer: getOrganizer,
      getVenue: getVenue,
      getEvent: getEvent,
      fetchEvent: fetchEvent,
      redirectIfNeeded: redirectIfNeeded,
      getSecondaryTickets: getSecondaryTickets,
      prepareTicketConfig: prepareTicketConfig,
      openWebSocket: openWebSocket,
      getQrCode: getQrCode,
      checkUserType: checkUserType,
      buyTickets: buyTickets,
      createSMOrder: createSMOrder,
      createOrderItems: createOrderItems,
      createOrder: createOrder,
      fetchOwnedTickets: fetchOwnedTickets,
      PButton: PButton,
      PInputNumber: PInputNumber,
      PCalendar: PCalendar,
      PRadioButton: PRadioButton,
      PDialog: PDialog,
      ValidationObserver: ValidationObserver,
      TicketPriceListSM: TicketPriceListSM,
      BChip: BChip,
      BMobileCart: BMobileCart,
      DateList: DateList,
      IconArrowBack: IconArrowBack,
      BImageWithBlurredBackground: BImageWithBlurredBackground,
      TicketPricePreview: TicketPricePreview,
      TicketPriceList: TicketPriceList,
      EventInfoPreview: EventInfoPreview,
      BAuth: BAuth,
      BActionsModal: BActionsModal,
      TicketFormatSelector: TicketFormatSelector
    };
  }
}));